export const formatNumber = (value: number, decimalsMin: number = 0, decimalsMax: number = 2): string => {
	return value.toLocaleString('de-DE', {
		minimumFractionDigits: decimalsMin,
		maximumFractionDigits: decimalsMax,
	});
};
